// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"691":"component---src-pages-index-tsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"691":"416ca71ffa45197e1807","883":"04196d8acfe93c798e98"}[chunkId] + ".js";
};